( function( $ ) {
	'use strict';

	$( function() {
		const $trigger = $( '.js-shop-sidebar h2' );
		const activeClass = 'is-active';
		const inactiveClass = 'is-inactive';

		$trigger.on( 'click', function() {
			const section = $( this ).parent();
			const content = $( this ).next();

			// If this section's content is hidden, show it
			if ( content.css( 'display' ) === 'none' ) {
				section.addClass( activeClass );
				section.removeClass( inactiveClass );

				content.slideDown( function() {
					// Add inline style to make sure content is displayed when resizing window down
					content.css( 'display', 'block' );
				});

			// If this section's content is showing, hide it
			} else {
				section.removeClass( activeClass );
				section.addClass( inactiveClass );

				content.slideUp();
			}
		} );
	} );
} )( jQuery );
